import { combineReducers } from "redux";

// reducer
import authReducer from "./reducer/auth";
import uiReducer from "./reducer/ui-reducer";
import roomProductReducer from "./reducer/roomProductReducer";
import dateReducer from "./reducer/dateReducer";
import roomHistoryReducer from "./reducer/roomHistoryReducer";
import chooseRoomReducer from "./reducer/chooseRoomReducer";
import modalOccReducer from './reducer/modalOccReducer';
import modalRoomBoxReducer from "./reducer/modalRoomBoxReducer";
import roomTypeReducer from "./reducer/roomTypeReducer";
import productHotelReducer from "./reducer/productHotelReducer";
import guestTypeReducer from "./reducer/guestTypeReducer";
import customerHotelReducer from "./reducer/customerHotelReducer";
import roomDepositReducer from "./reducer/roomDepositReducer";
import { loadingBarReducer } from "react-redux-loading-bar";

const rootReducer = combineReducers({
  authsd: authReducer,
  ui: uiReducer,
  loadingBar: loadingBarReducer,
  roomProduct : roomProductReducer,
  dateRoom : dateReducer,
  roomHistory : roomHistoryReducer,
  chooseRoom : chooseRoomReducer,
  modalOcc : modalOccReducer,
  modalRoomBox: modalRoomBoxReducer,
  roomType : roomTypeReducer,
  productHotel : productHotelReducer,
  guestTypes : guestTypeReducer,
  customerHotel : customerHotelReducer,
  roomDeposit : roomDepositReducer,
});

export default rootReducer;